import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';

import { RequestResultType } from '../../enums/request-result-type';
import { RequestResult } from '../../models';
import { JwtDecoded } from '../../models/authentication/jwt-decoded';
import { Token } from '../../models/authentication/token';
import { LOCALSTORAGE_KEYS, LocalStorageService } from '../local-storage/local-storage.service';
import { AuthenticationApiService } from './authentication.api.service';

@Injectable()
export class AuthenticationDomainService {
    constructor(
        private localStorageService: LocalStorageService,
        private authenticationApiService: AuthenticationApiService,
        private jwtHelper: JwtHelper) { }

    public login(email: string, password: string): Observable<RequestResult<void>> {
        return this.authenticationApiService.login(email, password)
            .do((result: RequestResult<Token>) => {
                if (result.requestResultType === RequestResultType.Success) {
                    this.storeToken(result.data);
                }
            }).map((result: RequestResult<Token>) =>
                new RequestResult(result.requestResultType));
    }

    public logout(): void {
        this.localStorageService.clearStorage();
    }

    public refreshtoken(refreshToken: string): Observable<Token> {
        return this.authenticationApiService.refresh(refreshToken)
            .map((result: RequestResult<Token>) => {
                if (result.requestResultType === RequestResultType.Success) {
                    return result.data;
                }
            });
    }

    public storeToken(token: Token): void {
        this.localStorageService.set(LOCALSTORAGE_KEYS.TOKEN, token);
    }

    public getCurrentToken(): Token {
        return this.localStorageService.getItem(LOCALSTORAGE_KEYS.TOKEN);
    }

    public getCurrentAccessToken(): string {
        const token: Token = this.getCurrentToken();
        if (token) {
            return token.access_token;
        }
        return null;
    }

    public getDecodedAccessToken(): JwtDecoded {
        const accessToken: string = this.getCurrentAccessToken();
        if (accessToken) {
            return this.jwtHelper.decodeToken(accessToken);
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/authentication/authentication.domain.service.ts